/** Structured boot telemetry (BUG-mentor-workspace-boot-01 Phase E). */

export const BOOT_TELEMETRY_EVENT = 'mentor_workspace_boot';
export const BOOT_TELEMETRY_LOG_PREFIX = '[mentor-boot]';

export function buildBootTelemetryPayload(bootData, { role, durationMs }) {
  const cohortList = bootData.cohortSummaries?.length
    ?? bootData.cohortFetch?.data?.length
    ?? 0;
  const sessionList = bootData.sessionSummaries?.length
    ?? bootData.sessionsFetch?.data?.length
    ?? 0;
  const cohortEnriched = bootData.normalizedCohortEntities?.length ?? 0;
  const sessionEnriched = bootData.normalizedSessions?.length ?? 0;
  const warnings = (bootData.bootWarnings || []).map(w => w.code);

  return {
    event: BOOT_TELEMETRY_EVENT,
    role: role || 'unknown',
    cohortList,
    cohortEnriched,
    sessionList,
    sessionEnriched,
    partial: Boolean(bootData.partial),
    fatal: Boolean(bootData.fatal),
    warnings,
    warningCount: warnings.length,
    durationMs: Math.max(0, Math.round(durationMs || 0)),
    ts: new Date().toISOString(),
  };
}

/**
 * Emit boot telemetry: structured console log (all envs) + optional gtag event when loaded.
 */
export function emitBootTelemetry(payload) {
  if (typeof console !== 'undefined' && console.info) {
    console.info(BOOT_TELEMETRY_LOG_PREFIX, payload);
  }

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', BOOT_TELEMETRY_EVENT, {
      event_category: 'workspace',
      event_label: payload.role,
      value: payload.durationMs,
      partial: payload.partial ? 1 : 0,
      fatal: payload.fatal ? 1 : 0,
      warning_count: payload.warningCount,
      cohort_list: payload.cohortList,
      session_list: payload.sessionList,
    });
  }
}